<template>
    <main>
        <div class="unlock-chain-container">
            <div class="chain" v-if="step < 5">
                <div class="chain-item">
                    <div class="chain-item__circle" v-bind:class="{'chain-item__circle--active': step >= 1}">1</div>
                    <div style="max-width: 90%">{{ $t('unlock.tx_chain.unlock_confirm') }}</div>
                </div>
                <div class="chain-line" v-bind:class="{'chain-line--active': step >= 2}"></div>
                <div class="chain-item">
                    <div class="chain-item__circle" v-bind:class="{'chain-item__circle--active': step >= 2}">2</div>
                    <div>{{ $t('unlock.tx_chain.balance_check') }}</div>
                </div>
                <div class="chain-line" v-bind:class="{'chain-line--active': step >= 3 || step === 2 && showInputField}"></div>
                <template v-if="showInputField">
                    <div class="chain-line-input-container">
                        <input v-model="sendToStakeAmount" type="number" inputmode="decimal" class="chain-line-input" />
                        <button v-on:click="sendStakeTx" class="chain-line-input__button">{{ $t('unlock.tx_chain.send') }}</button>
                    </div>
                    <div class="muted chain-line-input__note">{{ $t('unlock.tx_chain.enter_amount') }}</div>
                </template>
                <div class="chain-item">
                    <div class="chain-item__circle" v-bind:class="{'chain-item__circle--active': step >= 3}">3</div>
                    <div>{{ $t('unlock.tx_chain.stake_confirm') }}</div>
                </div>
                <div class="chain-line" v-bind:class="{'chain-line--active': step >= 4}"></div>
                <div class="chain-item">
                    <div class="chain-item__circle" v-bind:class="{'chain-item__circle--active': step >= 4}">4</div>
                    <div>{{ $t('unlock.tx_chain.stake_update') }}</div>
                </div>
            </div>

            <div v-else>
                <div class="success-container">
                    <div class="success-icon">
                        <icon-done-filled />
                    </div>
                    <h2>{{ $t('unlock.success_staking') }}</h2>
                    <p style="margin-top: 4px">{{ sendToStakeAmount }} TON {{ $t('unlock.were_sent_to_staking') }}</p>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import IconDoneFilled from '@img/icons/tonscan/transactions/tx-check.svg?inline';
import { postCheckTx } from '~/api/unlock';

const LOCKER_ADDRESS = 'EQDtFpEwcFAEcRe5mLVh2N6C0x-_hJEM7W61_JLnSF74p4q2';
const POOL_ADDRESS = 'EQD2_4d91M4TVbEBVyBF8J1UwpMJc361LKVCz6bBlffMW05o';

async function txSearchPolling(boc, interval = 5000, maxAttempts = 10) {
    let attempt = 0;

    while (attempt < maxAttempts) {
        try {
            // eslint-disable-next-line no-await-in-loop
            const tx = await postCheckTx(boc);

            if (tx?.found) return true;
        } catch (error) {
            // console.error(`Ошибка при попытке #${attempt + 1}:`, error);
        }

        attempt += 1;

        if (attempt < maxAttempts) {
            // eslint-disable-next-line no-await-in-loop
            await new Promise((resolve) => {
                setTimeout(resolve, interval);
            });
        }
    }

    return false;
}

export default {
    props: ['availableToWithdraw'],
    data() {
        return {
            showInputField: false,
            sendToStakeAmount: 0,
            step: 0,
        };
    },

    mounted() {
        this.sendToStakeAmount = this.$ton(this.availableToWithdraw, 9, true);
        // setTimeout(() => {
        //     this.step = 1;
        //     this.sendUnlockTx();
        // }, 1500);
    },

    methods: {
        async sendUnlockTx() {
            try {
                // Info about this BOC is on backend
                const body = 'te6cckEBAQEABwAACgAAAAB30uHyKA==';

                const { boc } = await this.$tonConnect.sendTransaction({
                    messages: [
                        {
                            address: LOCKER_ADDRESS,
                            amount: '1000000000', // 1 TON
                            payload: body,
                        },
                    ],
                    validUntil: Date.now() + 3 * 60 * 1000, // 3 minutes
                });

                // Next step
                this.step = 2;

                const tx = await txSearchPolling(boc);

                if (tx) {
                    this.showInputField = true;
                }
            } catch (err) {
                console.error('Transaction failed:', err);
            }
        },

        async sendStakeTx() {
            function convertToNano(amount) {
                return (amount * 10 ** 9).toString();
            }

            try {
                const amount = convertToNano(Number(this.sendToStakeAmount) + 1);
                const depositCell = 'te6ccsEBAQEADgAAABhH1UORAAAAAAAAJxEZbihG';

                const { boc } = await this.$tonConnect.sendTransaction({
                    messages: [
                        {
                            address: POOL_ADDRESS,
                            amount,
                            payload: depositCell,
                        },
                    ],
                    validUntil: Date.now() + 3 * 60 * 1000, // 3 minutes
                });

                // Next step
                this.step = 4;
                const tx = await txSearchPolling(boc);

                if (tx) {
                    // Next step
                    this.step = 5;
                    this.showInputField = true;
                }
            } catch (err) {
                console.error('Transaction failed:', err);
            }
        },
    },

    components: {
        IconDoneFilled,
    },
};
</script>

<style scoped lang="scss">
.unlock-chain-container {
    padding: 12px 16px;
    background-color: var(--card-background);

    h2 {
        margin: 0;
        padding: 0;
    }
}

.chain {
    width: 100%;
}

.chain-item {
    width: 100%;
    display: flex;
    gap: 8px;
    align-items: center;
    font-size: 16px;

    &:last-child {
        margin-bottom: 0;
    }

    &__circle {
        font-size: 13px;
        width: 24px;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        background-color: var(--body-light-muted-color);

        &--active {
            background-color: var(--big-blue-button-background);
        }
    }
}

.chain-line {
    display: block;
    width: 2px;
    height: 16px;
    border-radius: 4px;
    content: "";
    margin: 4px 0 4px 11px;
    background-color: var(--body-light-muted-color);

    &--active {
        background-color: var(--big-blue-button-background);
    }
}

.chain-line-input-container {
    display: flex;
    align-items: center;
    width: 100%;
    gap: 8px;
}

.chain-line-input {
    flex-grow: 1;
    color: var(--body-text-color);
    font-size: 16px;
    font-family: Cera Round Pro, Segoe UI, Arial, sans-serif;
    min-width: 110px;
    width: 100%;
    border-radius: 8px;
    border: 1px solid var(--card-border-color);
    background-color: transparent;
    margin-top: 4px;
    margin-bottom: 4px;
    box-sizing: border-box;
    padding: 8px 12px;
    display: flex;
    align-items: center;
    transition: .4s;

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    &__button {
        background-color: var(--big-blue-button-background);
        text-transform: uppercase;
        padding: 10px 16px;
        height: 38px;
        color: white;
        font-size: 13px;
        font-weight: 500;
        border-radius: 8px;
        cursor: pointer;
    }

    &__note {
        font-size: 13px;
        margin: 4px 0 12px;
        padding: 0 4px;
    }
}

/* Firefox */
input[type=number] {
    appearance: textfield!important;
    -moz-appearance: textfield!important;
}

.success-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
    justify-content: center;
    text-align: center;

    h2 {
        font-size: 22px;
        color: var(--badge-green-color);
    }
}

.success-icon {
    background: linear-gradient(135deg,#12a488,#30c281);
    border-radius: 50%;
    box-shadow: 0 4px 12px rgba(0,0,0,.1);
    box-sizing: border-box;
    color: #fff;
    height: 64px;
    margin: 16px 0;
    padding: 8px;
    width: 64px;

    svg {
        width: 48px;
        height: 48px;
        color: white;
        fill: white;
    }
}
</style>
